import { computed } from "vue";
import { useTerritoriosStore } from "@/store/territorios";
import { useTrabajoStore } from "@/store/useTrabajoStore";

export function useTerritoriosEstadisticas() {
  const territorios = useTerritoriosStore();
  const trabajo = useTrabajoStore();

  const asignados = computed(() => {
    let data = {};
    for (let i in territorios.asignadosActivos) {
      for (let j in territorios.asignadosActivos[i].territorios) {
        data[territorios.asignadosActivos[i].territorios[j]] = true;
      }
    }
    return data;
  });

  const build = (startDate, { onlyIncomplete = false } = {}) => {
    if (!startDate) {
      return [];
    }
    const startTimestamp = startDate.getTime();
    const result = [];

    for (const t of territorios.listWithName) {
      const uuid = t.uuid;
      if (!uuid) continue;
      const workData = trabajo.data[uuid];
      if (!workData) continue;

      const ciclos = trabajo.getCiclos(workData).filter((c) => c.inicio >= startTimestamp);
      const ultimoCiclo = ciclos.at(-1);

      if (onlyIncomplete && (ciclos.length === 0 || ultimoCiclo?.fin !== null)) {
        continue;
      }

      result.push({
        name: t.territorio_nombre,
        uuid,
        referencia: t.referencia,
        manzanasTotal: workData.manzanasTotal,
        manzanasPendientesTotal: workData.manzanasPendientesTotal,
        manzanasPendientes: workData.manzanasPendientes,
        asignado: !!asignados.value[t.territorio_nombre],
        ciclos,
        vecesCompletado: workData.vecesCompletado,
        ultimaCompletacion: workData.ultimaCompletacion,
        nuncaTrabajado: workData.registros.length === 0,
        enProgreso: workData.enProgreso,
      });
    }
    return result;
  };

  return { asignados, build };
}
